/**
 * Created by vladislav on 9/6/2022
 *
 * https://dev.vk.com/ru/bridge/overview
 */

const VKPlatform = function (pluginName) {
    this._isLegacyApp = connector.utils.getRequestParameters().viewer_id !== undefined;

    Platform.call(this, pluginName || connector.VK, {
        sdk: SdkManager.SDK_VK
    });

    this._detectPlatform();
};

VKPlatform.prototype = Object.create(Platform.prototype);
VKPlatform.prototype.constructor = VKPlatform;

VKPlatform.prototype._connect = function (callback) {
    this.askPermissions("", () => {
        this.resetCounter();

        callback(connector.STATUS_CONNECTED);
    });
};

VKPlatform.prototype._loadDataKeys = function () {
    return vkBridge.send("VKWebAppStorageGetKeys", {
        count: 1000,
        offset: 0
    }).then((data) => data.keys);
};

VKPlatform.prototype._detectPlatform = function () {
    let vkPlatform;
    if (this._isLegacyApp) {
        vkPlatform = connector.utils.getRequestParameters().platform;
        if (vkPlatform !== "web") {
            connector.info.isMobile = true;
        }
        if (["html5_ios", "html5_android"].includes(vkPlatform)) {
            connector.info.isInApp = true;
        }
    } else {
        vkPlatform = connector.utils.getRequestParameters().vk_platform;
        if (vkPlatform.startsWith("mobile_")) {
            connector.info.isMobile = true;
        }
        if (["mobile_android", "mobile_ipad", "mobile_iphone", "mobile_android_messenger", "mobile_iphone_messenger"].includes(vkPlatform)) {
            connector.info.isInApp = true;
        }
    }
};

VKPlatform.prototype.loadData = function () {
    return this._loadDataKeys().then((keys) => {
        if (keys.length === 0) {
            return Promise.resolve({});
        }

        return vkBridge.send("VKWebAppStorageGet", {
            keys
        }).then((data) => data.keys.reduce((res, data) => {
            try {
                const obj = JSON.parse(data);
                if (typeof obj === "object") {
                    data = obj;
                }
            } catch (e) { /* empty */ }

            res[data.key] = data;

            return res;
        }, {}));
    });
};

VKPlatform.prototype.setData = function (key, data) {
    return vkBridge.send("VKWebAppStorageSet", {
        key,
        value: typeof data === "object" ? JSON.stringify(data) : `${data}`
    }).then((data) => {
        if (!data.result) {
            return Promise.reject(new Error("Value was not set"));
        }

        return true;
    });
};

VKPlatform.prototype.askPermissions = function (permissions, callback) {
    const scope = {};

    permissions.split(",").forEach((permission) => {
        scope[permission] = false;
    });

    if (this.scope) {
        this.scope.split(",").forEach((permission) => {
            scope[permission] = true;
        });
    }

    if (Object.values(scope).every(Boolean)) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    this.callNative("VKWebAppGetAuthToken", {
        app_id: parseInt(connector.config[connector.info.source].appId),
        scope: Object.keys(scope).join(",")
    }, (code, data) => {
        if (code === connector.CODE_SUCCEED) {
            this.accessToken = data.access_token;
            this.scope = data.scope;
        }

        callback(code);
    });
};

VKPlatform.prototype.resetCounter = function () {
    this.callNative("VKWebAppCallAPIMethod", {
        method: "setCounter",
        params: {
            v: VKPlatform.API_VERSION,
            access_token: this.accessToken,
            counter: 0,
            increment: 0
        }
    }, (code) => {
        if (code === connector.CODE_FAILED) {
            console.log("VK.resetCounter error");
        }
    });
};

VKPlatform.prototype.getLocalStoragePrefix = function () {
    return "_VK";
};

VKPlatform.prototype._canCreateShortcut = function () {
    if (!connector._platformStorage.isReady) {
        return false;
    }

    return this._canAddToFavorites() || this._canAddToHomeScreen();
};

VKPlatform.prototype._canAddToFavorites = function () {
    const lastShown = +(connector._platformStorage.get(SimpleDataLoader.TYPES.SHORTCUT_CREATED) || 0);
    return lastShown + VKPlatform.SHORTCUT_INTERVAL < Date.now();
};

VKPlatform.prototype._canAddToHomeScreen = function () {
    if (!connector.info.isMobile) {
        return false;
    }

    const lastShown = +(connector.dataLoader.load(SimpleDataLoader.TYPES.HOME_SCREEN_ADDED) || 0);
    return lastShown + VKPlatform.SHORTCUT_INTERVAL < Date.now();
};

VKPlatform.prototype.callNative = function (method, params, callback) {
    callback = connector.utils.once(callback);

    if (!this.isConnected() && method !== "VKWebAppGetAuthToken") {
        callback(connector.CODE_FAILED);
        return;
    }

    if (["apps.", "friends."].some((prefix) => method.indexOf(prefix) === 0)) {
        params = {
            method,
            params: {
                v: VKPlatform.API_VERSION,
                access_token: this.accessToken,
                ...params 
            }
        };

        method = "VKWebAppCallAPIMethod";
    }

    vkBridge.send(method, params)
        .then((data) => callback(connector.CODE_SUCCEED, data))
        .catch((data) => callback(connector.CODE_FAILED, data));
};

VKPlatform.prototype.createShortcut = function (callback) {
    if (!this._canCreateShortcut()) {
        return;
    }

    if (this._canAddToFavorites()) {
        this.callNative("VKWebAppAddToFavorites", {}, (code) => {
            connector._platformStorage.set(SimpleDataLoader.TYPES.SHORTCUT_CREATED, Date.now());

            if (callback) {
                callback(code);
            }
        });
        return;
    }

    this.callNative("VKWebAppAddToHomeScreen", {}, (code) => {
        connector.dataLoader.save(SimpleDataLoader.TYPES.HOME_SCREEN_ADDED, Date.now());

        if (callback) {
            callback(code);
        }
    });
};

// VK forwards the fragment of an app link (vk.com/app<id>#<value>) into the app it opens. A legacy iframe app gets
// it as the "hash" query param - seen on the mergecraft staging app, whose frame has hash= and no fragment - and a
// current one may get it as its own fragment, so both are read. Channel tracking already lived there alone; a
// switchGame payload packs channel and crossId into it as "channel|crossId", crossId left off (no separator) when
// there is none, so a bare channel stays readable. An OK game's link adds a third part, the other
// Platform.CROSSPROMO_PAYLOAD_FIELDS as a query string: OK passes a VK game in OK nothing but the fragment.
VKPlatform.prototype._parsePayload = function (callback) {
    const params = connector.utils.getRequestParameters();

    // the query param comes decoded, the fragment as written: switchGame encodes the separator
    let hash = params.hash || window.location.hash.replace("#", "");
    try {
        hash = decodeURIComponent(hash);
    } catch (e) {
        console.log(`Can't decode hash: ${hash}`, e);
    }

    const [channel, crossId, extra] = (hash || "").split("|");

    params.channel = channel;
    if (crossId) {
        params.crossId = crossId;
    }
    if (extra) {
        Object.assign(params, connector.utils.getRequestParameters(`?${extra}`));
    }

    callback(params);
};

VKPlatform.prototype.canPassPayload = function () {
    return true;
};

VKPlatform.prototype.switchGame = function (url, payload, callback) {
    callback = callback || function () {};

    // cross promo passes the channel in the link, which VK does not forward - it has to travel in the hash
    const channel = payload && payload.channel || url && new URL(url).searchParams.get("channel") || "";
    const crossId = payload && payload.crossId;
    const hash = crossId ? `${channel}|${crossId}` : channel;

    // the rest of Platform.CROSSPROMO_PAYLOAD_FIELDS rides as plain query params - _parsePayload forwards the whole
    // params object as is; crossId is skipped here, it already travels in the hash above
    const extra = Platform.CROSSPROMO_PAYLOAD_FIELDS.filter((key) => key !== "crossId").reduce((acc, key) => {
        if (payload && payload[key] !== undefined) {
            acc[key] = payload[key];
        }
        return acc;
    }, {});

    // both slots are set - whichever one the target's runtime (legacy or current) actually reads
    const target = `${connector.utils.addSearchParams(url, { hash, ...extra })}#${encodeURIComponent(hash)}`;

    this.openUrl(target);
    callback(true);
};

VKPlatform.prototype.parseOtherWays = function (callback) {
    // https://dev.vk.com/ru/games/development/parameters/vk_ref
    const channels = {
        apps_games_collection: "collections",
        apps_games_featured: "featured",
        apps_games_game_of_week: "game_of_week"
    };

    const params = connector.utils.getRequestParameters();
    const referrer = [params.vk_ref, params.referrer].find(Boolean) || "";

    const channel = channels[referrer] || "";

    callback(channel);
};

VKPlatform.API_VERSION = "5.199";

VKPlatform.prototype.openUrl = function (url) {
    const link = document.createElement("a");
    link.setAttribute("target", "_blank");
    link.setAttribute("href", url);
    link.click();
};

VKPlatform.getPlatfrom = function () {
    return connector.utils.getRequestParameters().platform;
};

VKPlatform.SHORTCUT_INTERVAL = connector.utils.parseInterval("1 month");

VKPlatform.prototype.canSwitchGame = function () {
    return true;
};
